<template>
    <div class="page white_bg">
        <div class="paddingV12 paddingH16">
            <button class="button button_primary white" @click="getLocation()">获取定位</button>
        </div>
    </div>
</template>

<script>

import locationManager from "@/components/platformApi/locationManager";
import consoleHelper from "@/util/consoleHelper";

export default {
    name: "locationDemo",
    data () {
        return {
        }
    },
    methods : {
        getLocation() {

            locationManager.getLocation({}, (error, result) => {

                let latitude    = result.latitude; // 纬度，浮点数，范围为90 ~ -90
                let longitude   = result.longitude; // 经度，浮点数，范围为180 ~ -180。

                let geocoder = new qq.maps.Geocoder();

                geocoder.setComplete(function(result) {

                    consoleHelper.log(result);
                    consoleHelper.log(result.detail.address);
                });
                //若服务请求失败，则运行以下函数
                geocoder.setError(function() {
                    consoleHelper.log("地理位置地址查询失败");
                });

                geocoder.getAddress(new qq.maps.LatLng(latitude, longitude));
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
